import React, { useState } from 'react'
import { GiSpeaker } from "react-icons/gi";
export default function TextForm(props) {

    const [text, setText] = useState('');
    const handleupper = () => {
        let newtext = text.toUpperCase();
        setText(newtext)
        props.showalert("Text changed to uppercase", "success")
    }

    const handlelower = () => {
        let newtext = text.toLowerCase();
        setText(newtext)
        props.showalert("Text changed to lowercase", "success")
    }

    const handletitle = () => {
        let newtext = text.toLowerCase().replace(/(?:^|\s)\w/g, function (match) {
            return match.toUpperCase();
        });
        setText(newtext)
        props.showalert("Text changed to title", "success")
    }

    const handlechange = (event) => {
        setText(event.target.value)
    }

    const handleclear = (event) => {
        let newtext = "";
        setText(newtext);
        props.showalert("Text cleared", "success")
    }

    const handlecopy = (event) => {
        var newtext = document.getElementById("mybox");
        newtext.select();
        navigator.clipboard.writeText(newtext.value);
        props.showalert("Copied to clipboard!", "success")
        setTimeout(() => {
            newtext.selectionEnd = 0;
            newtext.selectionStart = 0;
        }, 500);
    }


    const handleSpeak = () => {
        if (!text) return;
        const synth = window.speechSynthesis;
        const utterance = new SpeechSynthesisUtterance(text);
        synth.speak(utterance);
    };
    return (
        <div className='w-3/4 mx-auto lg:w-1/2 flex flex-col h-[80vh] '>
            <h1 className='text-center text-3xl font-bold '>{props.heading}</h1>
            <div className=''>
                <div className='flex border-2 border-black my-4'>
                    <textarea id="mybox" value={text} onChange={handlechange} rows="6" placeholder='Enter any text here...' className='w-full resize-none outline-none   p-2 '>
                    </textarea>

                    <div onClick={handleSpeak} className='flex justify-center items-center cursor-pointer p-2'><GiSpeaker className='text-2xl' /></div>
                </div>

                <div className="flex justify-between mb-4">
                    <button disabled={text.split(/\s+/).filter((element) => { return element.length !== 0 }).length === 0} className="" onClick={handleupper}>Upper</button>

                    <button disabled={text.split(/\s+/).filter((element) => { return element.length !== 0 }).length === 0} className="btnset" onClick={handlelower}>Lower</button>

                    <button disabled={text.split(/\s+/).filter((element) => { return element.length !== 0 }).length === 0} className="btnset" onClick={handletitle}>Title</button>

                    <button disabled={text.length === 0} className="btnset" onClick={handleclear}>Clear</button>

                    <button disabled={text.length === 0} className="btnset" onClick={handlecopy}>Copy</button>


                </div>
            </div>

            <div className="" >
                <h2 className='text-center text-xl font-semibold'>Text Summary</h2>
                <div className='flex justify-around my-2'>

                    <p> Words: {text.split(/\s+/).filter((element) => { return element.length !== 0 }).length} </p>
                    <p>Characters: {text.length} </p>
                </div>
            </div>
        </div>
    )
}
